import { render, staticRenderFns } from "./AuthorAndEditor.vue?vue&type=template&id=66166c04&"
import script from "./AuthorAndEditor.vue?vue&type=script&lang=js&"
export * from "./AuthorAndEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports